import React from 'react';
import './CrossPlatformApp.css';

const CrossPlatformApp = () => {
  return (
    <div className="cross-platform-app-container">
      {/* Hero Section with Background Video */}
      <section className="hero-section-flutter">
        <video className="background-video" autoPlay loop muted>
          <source src="/videos/6.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-content">
          <h1>Flutter & React Native App Development</h1>
          <h2>
            Build and deploy quality cross-platform apps with Flutter & React Native
          </h2>
          <p>
            As a trusted app development partner, we can help you build platform-independent digital experiences with top-notch technologies like Flutter and React Native.
          </p>
        </div>
      </section>

      {/* Overview Section */}
      <section className="overview-section">
        <h2>Developing Scalable Multi-Platform Apps</h2>
        <p>
          Leverage our expertise in Flutter and React Native to build highly functional, natively compiled applications for web and mobile devices. Our team ensures seamless experiences across all platforms using a single codebase.
        </p>
        <p>
          Whether it's feature-rich mobile apps or dynamic web solutions, our experts can fulfill your business needs tailored specifically for your audience.
        </p>
      </section>

      {/* Flutter Services Section */}
      <section className="flutter-services-section-list">
        <h2>Flutter App Development Services We Offer</h2>
        <ul>
          <li>Custom Flutter App Development</li>
          <li>Flutter UI/UX Design Services</li>
          <li>App Migration & Upgradation</li>
          <li>App Maintenance & Support</li>
          <li>Testing & QA</li>
        </ul>
       <div class="flutter_why">
       <h3>Why Choose Flutter for App Development?</h3>
        <p>
          Flutter is a Google-backed framework that enables developers to create natively compiled applications for mobile, web, and desktop from a single codebase. 
          Some key benefits include:
        </p>
       </div>
        <ul>
          <li>Faster Development with Hot Reload</li>
          <li>Beautiful, Customizable Widgets</li>
          <li>High Performance Due to Native Compilation</li>
          <li>Wide Support for Both iOS and Android Platforms</li>
          <li>Rich Libraries for Animation and Design</li>
        </ul>
      </section>

      {/* React Native Services Section */}
      <section className="react-native-services-section-list">
        <h2>React Native App Development Services We Offer</h2>
        <ul>
          <li>Custom React Native App Development</li>
          <li>React Native UI/UX Design Services</li>
          <li>Cross-Platform Development for iOS and Android</li>
          <li>App Optimization and Maintenance</li>
          <li>React Native App Testing & QA</li>
        </ul>
        <div  class='contant_why'>
       
        <h3>Why Choose React Native for App Development?</h3>
        <p>
          React Native, backed by Meta, is a popular framework for building mobile apps that feel truly native. It offers:
        </p>
        </div>
    
        <ul>
          <li>Faster Development and Deployment</li>
          <li>Reusable Code for Android and iOS</li>
          <li>Rich Ecosystem with Numerous Libraries</li>
          <li>Live Reload for Quick Iteration</li>
          <li>Native Performance and Smooth Animations</li>
        </ul>
      </section>

      {/* Tools and Technologies Section */}
      <section className="tools-technologies-section-list">
        <h2>Tools & Technologies</h2>
        <h3>Frameworks</h3>
        <p>
          <img src="/images/tech/react-native-1-removebg-preview.png" alt="React Native" className="tech-logo" /> React Native, 
          <img src="/images/tech/flutter.png" alt="Flutter" className="tech-logo" /> Flutter, 
          <img src="/images/tech/images__2_-removebg-preview.png" alt="Node.js" className="tech-logo" /> Node.js
        </p>
        <h3>Languages</h3>
        <p>
          <img src="/images/tech/react-native-1-removebg-preview.png" alt="React" className="tech-logo" /> React Native
          <img src="/images/tech/png-transparent-flutter-logo-flutter-software-logo-social-media-logo-logo-technology-logo-3d-icon-thumbnail-removebg-preview.png" alt="React" className="tech-logo" /> Dart

        </p>
        <h3>Coding Tools</h3>
        <p>
          <img src="/images/tech/android-studio-icon.webp" alt="Android Studio" className="tech-logo" /> Android Studio, 
          <img src="/images/tech/visual-studio-code7642-removebg-preview.png" alt="Visual Studio Code" className="tech-logo" /> Visual Studio
        </p>
        <h3>Database</h3>
        <p>
          <img src="/images/tech/MySQL-Logo.wine-removebg-preview.png" alt="MySQL" className="tech-logo" /> MySQL
        </p>
        <h3>Cloud</h3>
        <p>
          <img src="/images/tech/Amazon-Web-Services-AWS-Logo.png" alt="AWS" className="tech-logo" /> AWS, 
          <img src="/images/tech/Firebase_Logo-removebg-preview.png" alt="Firebase" className="tech-logo" /> Firebase
        </p>
      </section>
    </div>
  );
};

export default CrossPlatformApp;
